import styled from "styled-components/macro";

export const StyledThumbsUp = styled.div`
  display: inline-block;
  position: relative;

  svg {
    width: 20px;
    height: 20px;
  }
`;
